import { advisorQuestionnairePath } from './advisorUris';
import { clientQuestionnairePath } from './clientUris';

//  Pages.
export const PageRealAssets = 'realAssets';
export const PagePersonalInformation = 'personalInformation';
export const PageFamilyInformation = 'familyInformation';
export const PageGoals = 'goals';
export const PageIncomeDetails = 'incomeDetails';
export const PageInvestmentAssets = 'investmentAssets';
export const PageSSIAndPensions = 'ssiAndPensions';
export const PageLiabilities = 'liabilities';
export const PageInsurance = 'insurance';
export const PageEstatePlanning = 'estatePlanning';
export const PageFinancialProfile = 'financialProfile';
export const PageOtherAdvisors = 'OtherAdvisors';
export const PageExpenses = 'Expense';

//  Sections.
export const Accountant = 'accountant';
export const Dependents = 'dependents';
export const Savings = 'savings';
export const Taxes = 'taxes';
export const HomeRelatedExpenses = 'homeRelatedExpenses';
export const TransportationExpenses = 'transportationExpenses';
export const DebtPayments = 'debtPayments';
export const LifestyleExpenses = 'lifestyleExpenses';
export const GroupLifeInsurance = 'groupLifeInsurance';
export const Liabilities = 'liabilities';
export const PersonalInfo = 'personalInfo';
export const PropertyInsurance = 'propertyInsurance';
export const AdvancedHealthCareDirective = 'advancedHealthCareDirective';
export const EducationAccounts = 'educationAccounts';
export const FamilyDetails = 'familyDetails';
export const LongTermCareInsurance = 'longTermCareInsurance';
export const SignificantOtherPersonalInfo = 'significantOtherPersonalInfo';
export const SignificantOtherContactInfo = 'significantOtherContactInfo';
export const SignificantOtherEmploymentInfo = 'significantOtherEmploymentInfo';
export const BankAccounts = 'bankAccounts';
export const EmployerSponsoredPlans = 'employerSponsoredPlans';
export const GeneralPowerOfAttorney = 'generalPowerOfAttorney';
export const IncomeDetails = 'incomeDetails';
export const SecondaryIncomeDetails = 'secondaryIncomeDetails';
export const IncomeTaxSummary = 'incomeTaxSummary';
export const MedicareInsurance = 'medicareInsurance';
export const PersonalRetirementAccounts = 'personalRetirementAccounts';
export const SocialSecurityBenefits = 'socialSecurityBenefits';
export const EmploymentInfo = 'employmentInfo';
export const GiftsToFamily = 'giftsToFamily';
export const InsuranceAgent = 'insuranceAgent';
export const NonRetirementAccounts = 'nonRetirementAccounts';
export const PrivateDisabilityInsurance = 'privateDisabilityInsurance';
export const Trust = 'trust';
export const Children = 'children';
export const EstatePlanningAttorney = 'estatePlanningAttorney';
export const GoalsAndObjectives = 'goalsAndObjectives';
export const Goals = 'goals';
export const InvestmentKnowledge = 'investmentKnowledge';
export const Notes = 'notes';
export const PrivateHealthInsurance = 'privateHealthInsurance';
export const Vehicles = 'vehicles';
export const ContactInfo = 'contactInfo';
export const GroupDisabilityInsurance = 'groupDisabilityInsurance';
export const InvestmentOther = 'investmentOther';
export const OtherProfessional = 'otherProfessional';
export const PrivateLifeInsurance = 'privateLifeInsurance';
export const Will = 'will';
export const DefinedPensionPlans = 'definedPensionPlans';
export const GroupHealthInsurance = 'groupHealthInsurance';
export const InvestmentProfile = 'investmentProfile';
export const PersonalAssets = 'personalAssets';
export const Properties = 'properties';
export const W2IncomeDetailsSectionKey = 'w2IncomeDetailsSection';
export const W2IncomeDetailsSignificantOtherSectionKey = 'w2IncomeDetailsSectionSO';

export const editQuestionnaire = (page, args = {}) => {
  const {
    householdId,
    section,
    isAgent,
  } = args;

  const path = isAgent ? advisorQuestionnairePath : clientQuestionnairePath;
  const params = new URLSearchParams();

  if (householdId) {
    params.append('householdId', householdId);
  }

  if (section) {
    params.append('section', section);
  }

  return `${path}/${page}?${params.toString()}`;
};

export const mapSectionToPage = (section) => {
  switch (section) {
    //  Personal Information.
    case PersonalInfo:
    case ContactInfo:
    case EmploymentInfo:
    case SignificantOtherPersonalInfo:
    case SignificantOtherContactInfo:
    case SignificantOtherEmploymentInfo:
      return PagePersonalInformation;

    //  Family Information.
    case Children:
    case Dependents:
    case FamilyDetails:
      return PageFamilyInformation;

    //  Goals.
    case GoalsAndObjectives:
    case Goals:
      return PageGoals;

    //  Income Details.
    case IncomeDetails:
    case SecondaryIncomeDetails:
    case IncomeTaxSummary:
    case W2IncomeDetailsSectionKey:
    case W2IncomeDetailsSignificantOtherSectionKey:
      return PageIncomeDetails;

    //  Investment Assets.
    case BankAccounts:
    case NonRetirementAccounts:
    case EducationAccounts:
    case PersonalRetirementAccounts:
    case EmployerSponsoredPlans:
      return PageInvestmentAssets;

    //  SSI and Pensions.
    case DefinedPensionPlans:
    case SocialSecurityBenefits:
      return PageSSIAndPensions;

    //  Liabilities.
    case Liabilities:
      return PageLiabilities;

    //  Insurance.
    case PropertyInsurance:
    case GroupHealthInsurance:
    case GroupDisabilityInsurance:
    case GroupLifeInsurance:
    case PrivateHealthInsurance:
    case MedicareInsurance:
    case PrivateDisabilityInsurance:
    case LongTermCareInsurance:
    case PrivateLifeInsurance:
      return PageInsurance;

    //  Real assets.
    case Properties:
    case PersonalAssets:
    case Vehicles:
    // case Properties:
      return PageRealAssets;

    //  Estate Planning.
    case Will:
    case GeneralPowerOfAttorney:
    case AdvancedHealthCareDirective:
    case Trust:
    case GiftsToFamily:
      return PageEstatePlanning;

    //  Financial Profile.
    case InvestmentProfile:
    case InvestmentKnowledge:
    case InvestmentOther:
      return PageFinancialProfile;

    //  Other Advisors.
    case Accountant:
    case EstatePlanningAttorney:
    case InsuranceAgent:
    case OtherProfessional:
      return PageOtherAdvisors;

    //  Expenses.
    case Savings:
    case Taxes:
    case HomeRelatedExpenses:
    case DebtPayments:
    case LifestyleExpenses:
      return PageExpenses;

    default:
      return '';
  }
};

export const mapBeneficiaryToSection = (beneficiaryType) => {
  switch (beneficiaryType) {
    case 'Traditional':
      return PersonalRetirementAccounts;
    case 'Mutual Fund':
    case 'Trust':
    case 'Brokerage':
    case 'Stock':
    case 'Annuity':
    case 'Other':
      return NonRetirementAccounts;
    case 'Group Life':
      return GroupLifeInsurance;
    case 'Term':
    case 'Whole life':
    case 'Universal life':
    case 'Variable life':
      return PrivateLifeInsurance;
    default:
      return BankAccounts;
  }
};

export const mapExpenseTypeToSection = (expenseType) => {
  switch (expenseType) {
    case 'savings':
      return Savings;
    case 'taxes':
      return Taxes;
    case 'transportation':
      return TransportationExpenses;
    case 'debt':
      return DebtPayments;
    case 'lifestyle':
      return LifestyleExpenses;
    case 'housing':
      return HomeRelatedExpenses;
    default:
      return BankAccounts;
  }
};
